import { Injectable } from '@angular/core';
import { PortalApiRepository } from '../../../../core/repositories/portal-api-repository';
import {
  ProvidersDTO,
  HRISIntegrationDTO,
  HRISIntegrationPostDTO,
  HRISIntegrationPutDTO,
  HRISIntegrationSyncResponse,
} from '../models/HRISIntegrationDTO';
import { CurrentUserState } from '../../../../core/store/current-user/current-user.state';
@Injectable({
  providedIn: 'root',
})
export class HrisIntegrationService extends PortalApiRepository {
  getProviders() {
    return this.get<ProvidersDTO[]>(`/HrisIntegrations/Providers`);
  }

  postHRISIntegration(externalId: HRISIntegrationDTO['externalId']) {
    const organizationId = this.store.selectSnapshot(
      CurrentUserState.organizationId,
    );

    if (!organizationId) {
      throw new Error('No organizationId found');
    }

    return this.post<HRISIntegrationPostDTO, HRISIntegrationDTO>(
      '/HrisIntegrations/',
      {
        externalId: externalId,
        organizationId: organizationId,
      },
    );
  }

  deleteHRISIntegration(hrisIntegrationId: HRISIntegrationDTO['id']) {
    return this.delete<void>(`/HrisIntegrations/${hrisIntegrationId}`);
  }

  putHRISIntegration(
    hrisIntegrationId: HRISIntegrationDTO['id'],
    data: HRISIntegrationPutDTO,
  ) {
    return this.put<HRISIntegrationPutDTO, HRISIntegrationDTO>(
      `/HrisIntegrations/${hrisIntegrationId}`,
      data,
    );
  }

  sync(hrisIntegrationId: HRISIntegrationDTO['id']) {
    return this.post<void, HRISIntegrationSyncResponse>(
      `/HrisIntegrations/${hrisIntegrationId}/sync`,
    );
  }
}
